'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mn_MN = require('../locale/mn_MN');

var _mn_MN2 = _interopRequireDefault(_mn_MN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _mn_MN2['default'];